import { Plugin } from "grapesjs";
import loadComponents from "./component";
import loadBlocks from "./block";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "BranchList",
    label: "CourierBranchList",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "courier-branch-list",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
